// deps
import React, { memo } from "react";

// internal deps
import { Image, useEffectOnce } from "@swiggy-private/core-ui";

// components
import { CartGroupContainer } from "@cart-ui/components/cart-group";

// types
import { RenderingDetails } from "@swiggy-private/cart-types";

// styles
import styles from "./SelfDeliveryInstruction.scss";

// helpers
import { getSelfDeliveryImgURL } from "@cart-ui/helpers/SelfDeliveryInstructions";

export interface SelfDeliveryInstructionProps {
    itemData: RenderingDetails;
    onImpressionSelfDeliveryInstruction: VoidFunction;
}

const SelfDeliveryInstruction: React.FC<SelfDeliveryInstructionProps> = ({
    itemData,
    onImpressionSelfDeliveryInstruction,
}: SelfDeliveryInstructionProps) => {
    const { meta: { self_delivery_presentation_info: selfDeliveryInfo } = {} } = itemData;
    const { title, image_id: imgId, subtitle } = selfDeliveryInfo || {};

    useEffectOnce(() => {
        onImpressionSelfDeliveryInstruction();
    });

    return (
        <>
            <CartGroupContainer className={styles.contentV2}>
                <div className={styles.contentBox}>
                    <h2 className={styles.contentTitle}>{title}</h2>
                    <p className={styles.contentSubtitle}>{subtitle}</p>
                </div>
                <Image imageUrl={getSelfDeliveryImgURL(imgId)} className={styles.contentImg} />
            </CartGroupContainer>
        </>
    );
};

export default memo(SelfDeliveryInstruction);
